import  React from 'react'
//import Layout = require("../../layout");
//import Layout1 = Layout.Layout;

export interface ReadOnlyProps {
    label: string
    labelContent: string
    className?: string
    layout?: ReadLayout
}

export enum ReadLayout {
    Vertical,
    Horizontal
}

export const ReadOnly: React.FC<ReadOnlyProps> = (props: ReadOnlyProps) => {
    const {
        label, labelContent, className, layout
    } = props

    let output: any
    if (layout === ReadLayout.Vertical) {
        output = <div className={`${className} mt-4`}>
            <div className="mb-2">{label}</div>
            <div className="p-2" style={{ backgroundColor: '#f5f5f5', maxWidth: '350px' }}>{
                labelContent}</div>
        </div>
    } else {
        output = <div className={`row ${className} mt-4`}>
            <div className="mb-2 col-6">{label}</div>
            <div className="p-2 col-6" style={{ backgroundColor: '#f5f5f5', maxWidth: '350px' }}>{
                labelContent}</div>
        </div>
    }

    return (
        <>
            {output}
        </>
    )
}

ReadOnly.defaultProps = {
    className: '',
    layout: ReadLayout.Vertical
}
